import { MatDialogConfig } from "@angular/material/dialog";

export function getPosMultipleQuantitiesCartProductConfirmationModalDialogConfig() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '600px';
    dialogConfig.panelClass = ['up-dialog-container', 'messageBox'];
    return dialogConfig;
}